import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, LinearProgress } from "@mui/material";

const LoadingBackdrop = (props) => {
  return (
    <div>
      <Backdrop
        sx={{
          color: "secondary.light",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={props.open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default LoadingBackdrop;
